import { OptionItem } from "@/model/OptionItem";

export interface FieldConfig<T = unknown> {
  prop: keyof T;
  label: string;
  type:
    | "text"
    | "select"
    | "number"
    | "address"
    | "tel"
    | "password"
    | "email"
    | "numberText"
    | "int"
    | "pick";
  placeholder?: string;
  options?: { name: string }[]; // select与sheet类型用
  unit?: string;
  icon?: string;
  dictApi?: () => Promise<OptionItem[]>;
  keyProp?: string;
  sub?: boolean; // 是否是一个输入框的子框
}

// 用来将emoj的内容筛掉
export const emojRanges = [
  "\ud83c[\udf00-\udfff]", // U+1F300 to U+1F3FF
  "\ud83d[\udc00-\ude4f]", // U+1F400 to U+1F64F
  "\ud83d[\ude80-\udeff]", // U+1F680 to U+1F6FF
  "[\u2700-\u27BF]", // 装饰符号（非CJK专用）
  "[\uFF00-\uFFEF]", // 全角ASCII、全角中英文标点、半宽片假名、半宽平假名、半宽韩文字母
  "[\u3300-\u33FF]", // CJK特殊符号（日期合并）
  "[\u2600-\u26FF]", // 杂项符号（非CJK专用）
  "[\uFE10-\uFE1F]", // 中文竖排标点
  "[\uFE30-\uFE4F]", // CJK兼容符号（竖排变体、下划线、顿号）
  "ぇ|▉|ヾ|▽|‘|′|`|Φ|╮|ω|ก|̀|ฅ|⊿|ớ|₃|ờ|ھ|♪|Θ|θ|『|˘|³|♥|•|́|ε|๑|٥|º|ั|ơ|∪|◎|∞|з|٩" +
    "|>|<|۶|◡|н|›|‹|็|ϖ|ミ|◔|‸|、|⊙|┌|∑|◇|┘|ヽ|◕|‿|╰|¬|●|┓|≖|✧|┏|و|˙|̅|ง|υ|๛|д|ʕ|ʔ|ツ|͡|Ծ|∀|Д|゜|" +
    "ロ|ノ|Σ|っ|°|△|||∵|Å|π|┬|│|╥|└|^|ʘ|∙|̆|̯|“|▔|□|ิ|╬|ξ|[|▓|]|¦|」|∠|ゝ|▂|φ|щ|ฺ|ˇ|⺻|…|‾|̑|⌣|˖|≥|≤|づ" +
    "|¯|ԅ|ˍ|ڡ|´|ゞ|☆|✿|๏|┴|—|≻|╧|╯|═|╘|╛|┻|━|ਛ|ᕤ|┙|∧|へ|┯|─|·|⍛|♫|♬|ィ|ェ|★|ܫ|〃|∇|╭|†|▃|▅|▆|▇|ó|ò|" +
    "≡|つ|⌒|∩|ื|▿|ŏ|΄|◞|౪|◟|‵|ˉ|◍|ᕦ|◝|◜|ಠ|⊖|ℰ|⋆|┗|┛|▰|⑅|▼|◉|ൠ|‧|◑|◐|ू|Ⴚ|ტ|Ⴢ|ڼ|☍|⁰|◠|✪|ʅ|ʃ|ლ|இ|⁾|☉|　| " +
    "ↀ|ѡ|͜|ʖ|ˊ|ˋ|⊂|≧|≦|○|ブ|ु|੭|Ф|♡|ღ|→|←|᷄|⁃|”|σ|ಥ|̼|ຶ|̮|༎|̥|థ|ι|┳|̤|ॕ|⌓|ಗ|ཀ|͝|┐|ˡ|ー|メ|◒|ᖛ|ヘ|ཽ|∂|ψ|೭|˵|̴|͒|ົ|" +
    "౨|☝|՞|ਊ|⃔|⌄|⍢|⁼|₌|ऀ|⁺|᾽|︴|ｕ|ｏ|＝|ꈨ|︺|︹|／|＼|＠|꒪|ㄏ|ㄟ|＊|Ｕ|（|Ｏ|＾|︵|－|﹁|﹀|＜|＞|﹃|︶|）|ｍ " +
    "|，|꒱|︿|꒰|눈|﹏|＿|ꇴ|＋|ㅁ|！|ㅂ|ﻌ|｀|．|０|ㆀ|＃|；|﹌|？|：|３|ｼ|｜|￫|｢|｡|～|､|ﾟ|｣|ｪ|･|ﾞ|ﾍ|ﾒ|ﾉ|ｰ|￢|￣|￩",
];
